var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-body"},[_c('div',{staticClass:"page-edit-layout-container"},[_vm._t("button"),_vm._t("default")],2),_c('div',{staticClass:"page-edit-layout-footer"},[_c('billing-info',{attrs:{"billingInfo":_vm.value}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }